import React from 'react';
import { useTranslation } from 'react-i18next';

import { Profile } from '../../../models/UserStore';
import { AvatarNode } from '../AvatarNode';

import styles from './ReferredUserCell.module.css';

type ReferredUserCellProps = {
  profile: Profile;
  purchasedAt?: Date;
  confirmedReward?: string;
  potentialReward?: string;
};

export const ReferredUserCell = (props: ReferredUserCellProps) => {
  const { profile, purchasedAt, confirmedReward, potentialReward } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <AvatarNode profile={profile} size={64} />
      <div className={styles.info}>
        <p className={styles.name}>{profile.name}</p>
        <p className={styles.detail}>
          {t('Purchased: ')}
          {purchasedAt ? purchasedAt.toLocaleDateString() : '---'}
        </p>
        {confirmedReward && (
          <p className={styles.reward}>
            {t('Confirmed Reward: ')}
            <span style={{ color: '#3597E9' }}>{confirmedReward}</span>
          </p>
        )}
        {!confirmedReward && potentialReward && (
          <p className={styles.reward}>
            {t('Potential Reward: ')}
            <span style={{ color: '#F79401' }}>{potentialReward}</span>
          </p>
        )}
      </div>
    </div>
  );
};
